import { accountNotificationsUrl } from '../urls';
import refresh from '../refresh';

export async function getAccountNotifications() {
  return refresh(async () => {
    const response = await fetch(accountNotificationsUrl, {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
      },
    });
    return response;
  });
}

export async function patchAccountNotificationsRead() {
  return refresh(async () => {
    const response = await fetch(accountNotificationsUrl, {
      method: 'PATCH',
      headers: {
        Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
      },
    });
    return response;
  });
}
